import { render, staticRenderFns } from "./RebootReport.vue?vue&type=template&id=2d60aecd"
import script from "./RebootReport.vue?vue&type=script&lang=js"
export * from "./RebootReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports